export const Bio = {
  name: "Veera Prathap",
  roles: [
    "Full Stack Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  
  resume:"https://europa.eu/europass/eportfolio/api/eprofile/shared-profile/veera-prathap/527687c6-7b7d-49d4-ae03-38227f1ee6e7?view=html",
  linkedin: "https://www.linkedin.com/in/veera-prathap-995253222/",
  
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
    
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
     
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    
      {
        name: "Figma",
        image:
          "https://images.unsplash.com/photo-1633355444132-695d5876cd00?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "",
    role: "Working Student",
    company: "Mount Zion College Of Engineering And Technology.",
    date: " 2021 - Mar 2023",
    desc: "Full Stack Developer,Worked in Multiple Apllicaions in My College days.",
    skills: [
      "HTML",
      "Css",
      "SQL",
      "JavaScript",
      
    ],
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Mz%20logo.jpeg?alt=media&token=4a1f5511-bcae-45df-9ae1-f9ecd5a72fd1",
    school: "Mount Zion College Of Engineering And Technology",
    date: "Jul 2019 - May 2023",
    grade: "2.4 German Grade",
    desc: "I Completed Bachelor's degree in Computer Science and Engineering at Mount Zion College Of Engineering And Technology, Tamil Nadu.",
    degree: "Bachelor of Technology - Bachelor of Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Mvm%20Logo.png?alt=media&token=ec18ecda-c853-4efc-875d-8cad0131b136",
    school: "Karaikudi Maharishi Vidhya Mandir, Tamil Nadu",
    date: "Apr 2018 - Apr 2019",
    grade: "64.6%",
    desc: "I completed my class 12 high school education at Karaikudi Maharishi Vidhya Mandir, Tamil Nadu, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Mvm%20Logo.png?alt=media&token=ec18ecda-c853-4efc-875d-8cad0131b136",
    school: "Karaikudi Maharishi Vidhya Mandir, Tamil Nadu",
    date: "Apr 2016 - Apr 2017",
    grade: "83.6%",
    desc: "I completed my class 10 education at Karaikudi Maharishi Vidhya Mandir, Tamil Nadu, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
 
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/what%20app%20clone.png?alt=media&token=7709d3bf-47a9-4287-bc66-6c47cf5a265a",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Todo%20logo.jpg?alt=media&token=b8fec3b3-1c65-461f-89d3-d110660738ac",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
   
  },
  {
    id: 6,
    title: "Lifty",
    date: "Jun 2022",
    description:
      "A simple react app that helps the pepole to give and get the Lift while travelling.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/LIfty%20Logo.png?alt=media&token=fd9aba80-ac03-4c5f-805c-3b53dd22d003",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "android app",
    
  },
  {
    id: 7,
    title: "Quiz App",
    date: "2021",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Quiz%20Logo.jpg?alt=media&token=e1d2dd9a-8f6a-4035-ae73-a1fa67196c97",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
    
  },
  {
    id: 8,
    title: "Face Recognition",
    date: "2023",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Face%20Regonition%20Logo.webp?alt=media&token=dd400a59-f2fe-4b72-b18e-54ddad489941",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    
  },
  {
  id: 8,
    title: "Sentiment Analysis ",
    date: "2023",
    description:
      "It web Scrap the Customer Reviews From the Website Using Machile Learning Algorithm gives the sentimental analysis.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/amplified-time-375808.appspot.com/o/Sentimental%20Analysis.jpeg?alt=media&token=4a98a94b-cfcd-41ac-8696-3c592846bb9d",
    tags: ["Python", "Pandas",  "PyTorch", ],
    category: "machine learning",
    
  },
];


